import { createStateSelectorHook } from 'src/lib/sweetState';
import { RESOURCES } from 'src/data/performance';
import { PerformanceStore } from 'src/store';

const usePerformanceState = createStateSelectorHook(PerformanceStore, ['accounts']);

export const useResourcesAccounts = () => {
  const { accounts } = usePerformanceState();

  const resourcesAccounts = RESOURCES.map((channel) => {
    return accounts[channel]?.map((account) => {
      const url = account?.urls?.[0] || null;
      return { url, channel, ...account };
    });
  });

  return resourcesAccounts.filter((a) => a).flat();
};
